import { useApolloClient } from "@apollo/client";
import { useEffect } from "react";
import { Locale } from "@/shared/i18n/config";

export function useRefetchQueriesOnLocalChange({ locale }: { locale: Locale }) {
  const client = useApolloClient();

  useEffect(() => {
    client.refetchQueries({
      include: "active",
    });
  }, [client, locale]);
}
